"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      form: {},
      son_id: this.$route.query.son_id,
      level: this.$route.query.level || 1
    };
  },
  mounted: function mounted() {
    this.getDetail();
  },
  methods: {
    /**
     * 获取信息
     */
    getDetail: function getDetail() {
      var _this = this;
      var url = 'agentapi/sttuf/check_contract';
      if (this.level == 1 && this.checkRoles(['terminal'])) url = 'agentapi/sttuf/check_platform_contract';
      this.$get(url, {
        aid: this.son_id
      }).then(function (res) {
        var form = _this.pickKeys(res, ['date_type', 'begin', 'contract_renew_fee', 'taked_deposite', 'taked_months']);
        if (_this.level == 1 && _this.checkRoles(['terminal'])) {
          form.begin = form.begin ? form.begin + '000' : form.begin;
          form.end = form.end ? form.end + '000' : form.end;
          form.date_type = form.date_type == null ? 1 : form.date_type;
        }
        for (var i in res.contract_url) {
          form.contract_url = form.contract_url || [];
          form.contract_url.push({
            url: res.contract_url[i]
          });
        }
        for (var i in res.identity_url) {
          form.identity_url = form.identity_url || [];
          form.identity_url.push({
            url: res.identity_url[i]
          });
        }
        for (var i in res.extra_url) {
          form.extra_url = form.extra_url || [];
          form.extra_url.push({
            url: res.extra_url[i]
          });
        }
        _this.form = form;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = JSON.parse(JSON.stringify(this.form)),
        url = 'agentapi/sttuf/edit_contract';
      params.aid = this.son_id;
      params.contract_url = this.arrayKeys(params.contract_url, 'url');
      params.identity_url = this.arrayKeys(params.identity_url, 'url');
      params.extra_url = this.arrayKeys(params.extra_url, 'url');
      if (this.level == 1 && this.checkRoles(['terminal'])) {
        url = 'agentapi/sttuf/edit_platform_contract';
      }
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        history.back();
      });
    }
  }
};